import React from "react";
import StickyNavbar from "./StickyNavbar/StickyNavbar.js";

export default (props) => (
  <StickyNavbar {...props} />
)
